const PrivacyPolicyTranslations = {
  'en-US': {
    pageTitle: 'Privacy Policy',
    hero: {
      title1: 'Privacy',
      title2: 'Policy',
      desc: 'At aitrade.ai, your privacy is our priority. This Privacy Policy outlines how we collect, use, store, and protect your personal data to ensure transparency and trust.',
      desc2:
        'Please read this Privacy Policy carefully to understand how we handle your data and your rights regarding your personal information.',
    },
    sections: {
      intro: {
        title: 'Introduction',
        content:
          'Welcome to aitrade.ai. We are committed to safeguarding your privacy and ensuring that your personal information is handled securely and responsibly. This Privacy Policy explains how we collect, use, disclose, and protect your information when you interact with our website, platform, or services. By using our services, you agree to the terms outlined in this policy. If you do not agree with any part of this policy, please discontinue using our services.',
      },
      collection: {
        title: 'Information We Collect',
        content:
          'We collect various types of information to provide and improve our services. This includes:\n' +
          '- Personal Information: Such as your name, email address, phone number, billing address, and payment details.\n' +
          '- Account Information: Details you provide when creating an account, including usernames and passwords.\n' +
          '- Usage Data: Information about how you interact with our website and services, such as IP addresses, browser type, device identifiers, pages visited, and time spent on the platform.\n' +
          '- Cookies and Tracking Technologies: Data collected through cookies or similar technologies to enhance user experience and analyze site performance.',
      },
      usage: {
        title: 'How We Use Your Information',
        content:
          'We use the information we collect for the following purposes:\n' +
          '- Service Delivery: To provide access to our platform and services.\n' +
          '- Personalization: To tailor content and recommendations based on your preferences.\n' +
          '- Communication: To respond to inquiries, provide customer support, or send important updates about our services.\n' +
          '- Analytics: To analyze usage trends and improve the functionality of our platform.\n' +
          '- Security: To detect and prevent fraud or unauthorized access.\n' +
          '- Legal Compliance: To comply with applicable laws, regulations, or legal requests.',
      },
      sharing: {
        title: 'Sharing of Information',
        content:
          'We value your trust and do not sell your personal information. However, we may share your data in the following circumstances:\n' +
          '- Service Providers: With trusted third-party vendors who assist us in operating our platform (e.g., payment processors or hosting providers).\n' +
          '- Legal Obligations: When required by law or in response to valid legal requests (e.g., subpoenas or court orders).\n' +
          '- Business Transfers: In the event of a merger, acquisition, or sale of assets involving aitrade.ai.\n' +
          '- Consent: With your explicit consent for specific purposes.',
      },
      security: {
        title: 'Data Security',
        content:
          'We take data security seriously and implement industry-standard measures to protect your personal information from unauthorized access, alteration, disclosure, or destruction. These measures include encryption protocols, secure servers, firewalls, and regular security audits. However, no system is completely secure. We encourage you to take precautions such as safeguarding your account credentials.',
      },
      rights: {
        title: 'Your Rights',
        content:
          'As a user of aitrade.ai, you have several rights regarding your personal data:\n' +
          '- Access: You can request access to the personal data we hold about you.\n' +
          '- Correction: You can request corrections to inaccurate or incomplete data.\n' +
          '- Deletion: You can request the deletion of your personal data where applicable.\n' +
          '- Data Portability: You can request a copy of your data in a portable format.\n' +
          '- Marketing Preferences: You can opt out of receiving marketing communications at any time by following the instructions provided in those communications or contacting us directly.',
      },
      changes: {
        title: 'Changes to This Policy',
        content:
          'We may update this Privacy Policy periodically to reflect changes in our practices or legal requirements. Significant updates will be communicated through prominent notices on our website or via email. We encourage you to review this policy regularly to stay informed about how we protect your data.',
      },
      contact: {
        title: 'Contact Us',
        content:
          'If you have any questions about this Privacy Policy or how we handle your data, please contact us at:\n\nEmail: office@aitrade.ai\nAddress: [Insert Company Address Here]\n\nWe are committed to addressing your concerns promptly and transparently.',
      },
      cookies: {
        title: 'Cookies and Tracking Technologies',
        content:
          'Our website uses cookies and similar tracking technologies to enhance user experience and analyze site performance. Cookies help us remember preferences, track user behavior on our site for analytics purposes, and deliver personalized content. You can manage cookie preferences through your browser settings. Please note that disabling cookies may affect certain functionalities of our website.',
      },
      minors: {
        title: 'Minors',
        content:
          'Our services are not intended for individuals under the age of 18. We do not knowingly collect personal information from minors without parental consent. If we become aware that we have inadvertently collected such information, we will delete it promptly. Parents or guardians who believe their child has provided us with personal information should contact us immediately at office@aitrade.ai.',
      },
      internationalTransfers: {
        title: 'International Data Transfers',
        content:
          'As an international company providing global services, we may transfer your personal data across borders for processing or storage purposes. These transfers are conducted in compliance with applicable data protection laws. Where required by law, we implement safeguards such as Standard Contractual Clauses (SCCs) to ensure adequate protection of your data during international transfers.',
      },
      legalBasis: {
        title: 'Legal Basis for Processing',
        content:
          'We process your personal data based on one or more of the following legal bases:\n' +
          '- Consent: When you provide explicit consent for specific purposes (e.g., marketing communications).\n' +
          '- Contractual Necessity: When processing is necessary to fulfill contractual obligations (e.g., providing access to paid services).\n' +
          '- Legitimate Interests: When processing is required for legitimate business purposes (e.g., improving service functionality) without overriding your fundamental rights.\n' +
          '- Legal Obligations: When processing is required to comply with legal obligations (e.g., tax reporting).',
      },
      dataRetention: {
        title: 'Data Retention',
        content:
          'We retain your personal data only as long as necessary for the purposes outlined in this policy or as required by law. Once retention periods expire:\n' +
          '- Personal data is securely deleted or anonymized.\n' +
          '- Certain records may be retained longer if required for legal compliance (e.g., tax records) or legitimate business interests.',
      },
    },
  },
}

export default PrivacyPolicyTranslations
